export type AdminTrialAction = 'admin-provision-trial-org' | 'send-trial-welcome'

/** Each request obtains the current session; no shared credential is available to this client. */
export function createAdminTrialRequest(
  getAccessToken: () => Promise<string | null>, fetchImpl: typeof fetch = fetch,
) {
  return async (action: AdminTrialAction, payload: Record<string, unknown>): Promise<Response> => {
    const token = await getAccessToken()
    if (!token) throw new Error('Your admin session has expired. Please sign in again.')
    return fetchImpl(`https://api.jumpstart.co.il/functions/v1/${action}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    })
  }
}
